module.exports = __webpack_public_path__ + "static/media/frog(27).10411a85.PNG";